(function () {
  var STORAGE_KEY = 'scuae_wishlist';

  // Storage format: object keyed by product ID string
  // { "123456": { id, title, image, price, url } }

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      // Guard against legacy array format
      if (Array.isArray(parsed)) return {};
      return parsed || {};
    } catch (e) {
      return {};
    }
  }

  function saveWishlist(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function isWishlisted(productId) {
    return !!getWishlist()[String(productId)];
  }

  function addItem(productData) {
    var data = getWishlist();
    data[String(productData.id)] = productData;
    saveWishlist(data);
  }

  function removeItem(productId) {
    var data = getWishlist();
    delete data[String(productId)];
    saveWishlist(data);
  }

  function toggleItem(productData) {
    if (isWishlisted(productData.id)) {
      removeItem(productData.id);
      return false;
    } else {
      addItem(productData);
      return true;
    }
  }

  // --- UI helpers ---

  function updateBtn(btn, wishlisted) {
    btn.classList.toggle('wishlisted', wishlisted);
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function syncAllBtns() {
    var wishlist = getWishlist();
    document.querySelectorAll('.wishlist-btn[data-product-id]').forEach(function (btn) {
      updateBtn(btn, !!wishlist[btn.getAttribute('data-product-id')]);
    });
  }

  // --- Event: heart click (delegated) ---

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-product-id');
    if (!id) return;

    var productData = {
      id: parseInt(id, 10),
      title: btn.getAttribute('data-product-title') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: parseInt(btn.getAttribute('data-product-price') || '0', 10),
      url: btn.getAttribute('data-product-url') || ''
    };

    var added = toggleItem(productData);
    updateBtn(btn, added);

    // Pop animation
    btn.classList.remove('wishlist-pop');
    void btn.offsetWidth;
    btn.classList.add('wishlist-pop');
    btn.addEventListener('animationend', function () {
      btn.classList.remove('wishlist-pop');
    }, { once: true });

    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: { productId: productData.id, added: added }
    }));
  });

  // --- Sync on load + MutationObserver for AJAX cards ---

  document.addEventListener('DOMContentLoaded', function () {
    syncAllBtns();
    renderAccountWishlist();
    initRecPills();
  });

  var observer = new MutationObserver(function (mutations) {
    var needsSync = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.matches && node.matches('.wishlist-btn') || node.querySelector && node.querySelector('.wishlist-btn'))) {
          needsSync = true;
        }
      });
    });
    if (needsSync) syncAllBtns();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // --- Wishlist page renderer ---
  // Instead of stamping out card markup in JS, we fetch the EXACT card-product
  // snippet via Shopify's `?view=card` template route. That route renders
  // templates/product.card.liquid which uses `{% layout none %}` to skip the
  // theme wrapper and outputs ONLY a single <li class="grid__item">{card}</li>.
  // The heart on each fetched card stays a regular .wishlist-btn — the
  // delegated handler above toggles localStorage and fires `wishlist:changed`,
  // which re-triggers this renderer.

  function extractHandle(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function updateWishlistCount(n) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = '( ' + n + ' )';
    });
  }

  function renderAccountWishlist() {
    var data = getWishlist();
    var items = Object.values(data);
    // Always update the count — there might be a wishlist count badge in
    // the header even on pages that don't have the grid.
    updateWishlistCount(items.length);

    // Switch the wishlist page between empty and populated visual modes.
    // The inline init script in sections/wishlist-page.liquid sets this on
    // first paint; we keep it in sync as the user hearts/un-hearts items.
    var wrapper = document.querySelector('.wishlist-page');
    if (wrapper) {
      wrapper.setAttribute('data-wishlist-state', items.length > 0 ? 'populated' : 'empty');
    }

    var grid = document.getElementById('wishlist-account-grid');
    if (!grid) return;

    if (items.length === 0) {
      grid.innerHTML = '';
      return;
    }

    Promise.all(items.map(function (item) {
      var handle = extractHandle(item.url);
      if (!handle) return Promise.resolve('');
      return fetch('/products/' + handle + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (fragments) {
      grid.innerHTML = fragments.join('');
      // Mark heart buttons on freshly-fetched cards as wishlisted (the snippet
      // server-renders them in default state because there's no Liquid context
      // for localStorage).
      syncAllBtns();
    });
  }

  // Re-render account grid when wishlist changes (e.g. un-hearting from a card while on account page)
  document.addEventListener('wishlist:changed', function () {
    renderAccountWishlist();
  });

  // Public API
  window.Wishlist = {
    get: getWishlist,
    isWishlisted: isWishlisted,
    add: addItem,
    remove: removeItem,
    toggle: toggleItem
  };

  // --- Recommendation pill filter (client-side) ---
  function initRecPills() {
    var container = document.querySelector('.wishlist-rec');
    if (!container) return;
    var pills = container.querySelectorAll('.wishlist-rec__pill');
    var cards = container.querySelectorAll('.wishlist-rec__card');
    if (!pills.length || !cards.length) return;

    function showAll() {
      cards.forEach(function (c) { c.hidden = false; });
    }
    function filterTo(cat) {
      cards.forEach(function (c) {
        c.hidden = c.getAttribute('data-category') !== cat;
      });
    }

    var allPill = container.querySelector('.wishlist-rec__pill[data-category="__all__"]');

    function setActive(target) {
      pills.forEach(function (p) {
        var active = p === target;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.getAttribute('data-category');
        if (cat === '__all__') { setActive(allPill); showAll(); return; }
        var wasActive = pill.classList.contains('is-active');
        if (wasActive) { setActive(allPill); showAll(); return; }
        setActive(pill);
        filterTo(cat);
      });
    });
  }
})();
